module.exports = __webpack_public_path__ + "static/media/objective_arrow.f49c59e4.svg";